import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MemberForm from './MemberForm';
import reportWebVitals from './reportWebVitals';
import { FormDataProvider } from './components/FormDataProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FormDataProvider>
      <MemberForm />
    </FormDataProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
